// extracted by mini-css-extract-plugin
export default {"icon":"NotificationsCenter_icon__rJ-NZ","wrapper":"NotificationsCenter_wrapper__mmpiF","badge":"NotificationsCenter_badge__XUYzq"};